import { combineReducers } from 'redux-immutable';
import * as storage from 'redux-storage';
import immutableMerger from 'redux-storage-merger-immutablejs';
import { reducer as toastrReducer } from 'react-redux-toastr';

const context = require.context('./', true, /.*/);

const reducers = {};

reducers.toastr = toastrReducer;

let rootReducer;

context.keys().forEach((key) => {
  if (!(/\.js/).test(key) && !(/index/).test(key)) {
    const reducer = context(key).default;

    if ((/^\.\/root/).test(key)) {
      rootReducer = reducer;
    } else if (reducer) {
      const name = key.substring(2, key.length);

      reducers[name] = reducer;
    }
  }
});

if (!rootReducer) {
  rootReducer = (r) => r;
}

export default storage.reducer(rootReducer(combineReducers(reducers)), immutableMerger);



// WEBPACK FOOTER //
// ./app/reducers/index.js